const rankingItems = [
  { rank: 1, title: '暗夜追踪', type: '悬疑剧', trend: 'up', hot: '9.8', desc: '国产悬疑巅峰，结局反转封神' },
  { rank: 2, title: '星际拓荒者', type: '科幻电影', trend: 'up', hot: '9.5', desc: '视觉特效天花板级别' },
  { rank: 3, title: '笑声制造机 S6', type: '综艺', trend: 'up', hot: '9.3', desc: '首播破亿，笑点密集' },
  { rank: 4, title: '星辰冒险谭', type: '日漫', trend: 'stable', hot: '8.9', desc: '同步日本播出，口碑走高' },
  { rank: 5, title: '古装风华录', type: '古装剧', trend: 'up', hot: '8.6', desc: '服化道精良，收视黑马' },
  { rank: 6, title: '画梦师', type: '动画电影', trend: 'new', hot: '8.2', desc: '年度最佳动画，全系列上架' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            热度榜单
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            实时热度排名，看看大家都在追什么
          </p>
        </div>

        <div className="bg-background-100 border border-background-200 rounded-2xl overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 md:p-5 hover:bg-background-50 transition-colors cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-xl font-bold text-lg flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-background-200 text-foreground-600 text-xs rounded-full flex-shrink-0">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                <span
                  className={`text-xs font-bold ${
                    item.trend === 'up'
                      ? 'text-primary-600'
                      : item.trend === 'new'
                      ? 'text-secondary-600'
                      : 'text-foreground-400'
                  }`}
                >
                  {item.hot}
                </span>
                <i
                  className={`text-sm ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-600'
                      : item.trend === 'new'
                      ? 'ri-sparkling-line text-secondary-600'
                      : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}